export { ReactComponent as homeIcon } from './home.svg';
export { ReactComponent as homeActiveIcon } from './active/home.svg';
export { ReactComponent as candlestickIcon } from './candlestick.svg';
export { ReactComponent as candlestickActiveIcon } from './active/candlestick.svg';
export { ReactComponent as calendarIcon } from './calendar.svg';
export { ReactComponent as calendarActiveIcon } from './active/calendar.svg';
export { ReactComponent as userIcon } from './user.svg';
export { ReactComponent as userActiveIcon } from './active/user.svg';
export { ReactComponent as bellIcon } from './bell.svg';
export { ReactComponent as bellActiveIcon } from './active/bell.svg';
export { ReactComponent as bellMobileIcon } from './bellMobile.svg';
export { ReactComponent as bellMobileActiveIcon } from './active/bellMobile.svg';
export { ReactComponent as settingsIcon } from './settings.svg';
export { ReactComponent as settingsActiveIcon } from './active/settings.svg';
